import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8h-8.5a1.5 1.5 0 0 0 0 3h7.5","key":"svg-0"}],["path",{"d":"M10.5 11h-2a1.5 1.5 0 1 0 0 3h2.5","key":"svg-1"}],["path",{"d":"M9.5 14a1.5 1.5 0 0 0 0 3h1.5","key":"svg-2"}],["path",{"d":"M10.5 17a1.5 1.5 0 0 0 0 3h4.5a6 6 0 0 0 6 -6v-2v.208a6 6 0 0 0 -2.7 -5.012l-.3 -.196q -.718 -.468 -5.728 -3.286a1.5 1.5 0 0 0 -2.022 .536a1.87 1.87 0 0 0 .28 2.28l1.47 1.47","key":"svg-3"}]]

const IconHandFingerLeft = createReactComponent('outline', 'hand-finger-left', 'HandFingerLeft', __iconNode);

export default IconHandFingerLeft;